import React from 'react';

interface SpinnerProps {
  hasShadow?: boolean;
}

const Spinner: React.FC<SpinnerProps> = ({ hasShadow = false }) => {
  return (
    <div className={`mz-spinner ${hasShadow ? 'mz-spinner--shadow' : ''}`}>
      <div className="mz-spinner-circle"></div>
    </div>
  );
};

export default Spinner;
